import { useCallback, useState } from 'react'
import {
  readInboxGroupByWorkspace,
  writeInboxGroupByWorkspace,
} from '@/lib/inbox-layout-preferences'

/** Inbox folders index: group thread list by workspace (persisted). */
export function useInboxGroupByWorkspace(defaultGroup = true) {
  const [groupByWorkspace, setGroupByWorkspaceState] = useState(() =>
    readInboxGroupByWorkspace(defaultGroup),
  )

  const setGroupByWorkspace = useCallback((next: boolean) => {
    setGroupByWorkspaceState(next)
    writeInboxGroupByWorkspace(next)
  }, [])

  return { groupByWorkspace, setGroupByWorkspace }
}
